import React, { useEffect, useContext } from 'react';
import { getLogo }  from './LocalizedPictures'
import { setNewAnswer, calculateResult, clearAllAnswer } from '../Store'
import CountUp from 'react-countup';
import './QuestionStep/style/Result.css'
import './QuestionStep/style/landing.css'
import star from './QuestionStep/assets/star.png'
import cloud1 from './QuestionStep/assets/calculator.png'
import cloud2 from './QuestionStep/assets/cloud3.png'
import Socials from '../components/Socials'
import gifRresult from './QuestionStep/assets/16_pencil 2.gif'
import jpgResult from './QuestionStep/assets/static/16_pencil-2.jpg'
import './Home.css'
import { useHistory } from 'react-router-dom'
import './Gif.css'
import { AppContext} from '../contexts/AppProvider'
import { useLocalize } from 'localize-react';

const ThankYou = () => {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    let theNumber = calculateResult();
    let yearsNumber = theNumber * 12;
    const { translate } = useLocalize()

    return (
        <>
            <div className="middle">
                <div className="res-middle">
                    <img id="cloud1" className="cloud" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={cloud1} alt="" />
                    <img id="cloud2" className="cloud3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={cloud2} alt="" />
                    <img className="star rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                    <img className="star2 rotate2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                    <img className="star3 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />

                </div>
                <div className="question-container thanks-page">
                    <div className="resShareHold">
                        <img className="FormRresult" src={settings.isAnimationPause ? jpgResult : gifRresult} alt="" />
                    </div>
                    <div className="reHeader">{translate('Thank you for registration')}</div>
                    {/* <div class="ThanksecondHeader">
                        במייל כבר מחכה לכם החישוב.
                    </div>

                    <div className="ThankYouText">
                        אנחנו בבנק הדיגיטלי הראשון מתחייבים להיות איתכם
                        <br/>
                        שקופים והוגנים ושתדעו כמה בדיוק
                        <br/>
                        עולה לכם הבנק, בכל רגע.
                    </div> */}
                    <Socials />
                    <div className="ThankReslogo">
                        <img width="150" src={getLogo()} alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}



export default ThankYou

